import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const SuccessIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Success",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M27.24 6.78 12.23 21.79l-7.47-7.47A1.619 1.619 0 0 0 2 15.47c0 .45.18.85.47 1.14l8.62 8.61a1.62 1.62 0 0 0 2.28 0L29.53 9.07a1.619 1.619 0 0 0-1.15-2.76c-.45 0-.85.18-1.14.47"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M11 26.43c-.3 0-.59-.12-.81-.33l-8-8.01a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l7.17 7.17L27.31 6.22c.43-.46 1.16-.49 1.62-.05.46.43.48 1.16.05 1.62L11.83 26.07c-.21.23-.51.36-.82.36h-.02Z"
      })
    })
  }));
};